import React from 'react';
import VideoStream from './VideoStream';

function App() {
  return (
    <div style={{ background: '#000', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <VideoStream />
    </div>
  );
}

export default App;